// extracted by mini-css-extract-plugin
export default {"infoRow":"aDYCQ7sJqtAaiFrqrlJx","colorBox":"CqGXkYN0ow_TJPfynB7T","green":"NsyaXyphQlJwGFublIWf","blue":"EPLIBKekfrm8rW5gPa7F"};